<template>
  <div class="col-12">
    <DottedLineHeader :text="$t('more.bp_stats')"/>

    <div class="row" style="align-items: center; text-align: center;">
      <div class="col-md-6">
        <table class="bp-stats-table">
          <thead>
            <tr>
              <th></th>
              <th class="table-vtitle" v-for="label in timeRangeLabels" :key="'thead-' + label">{{$t(label)}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(key, index) in statusKeys" :key="'tkey-' + index">
              <td class="table-htitle">{{$t(statusLabels[index])}}</td>
              <td v-for="time in timeRangeKeys" :key="'ttime-' + time">{{sharedTest && sharedTest.stats.bp[time][key]}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-md-6">
        <RadioButtonGroup v-if="!printing" name="bp-stats-filter" :items="timeRangeLabels" :values="timeRangeKeys" @valueChanged="filterValueChanged" style="display: block;"/>
        <span v-if="printing" class="mb-3" style="display: block;">{{$t("more.selected_time_range")}} <span class="selected-time-range">{{$t(timeRangeLabels[timeRangeKeys.indexOf(selectedTimeRange)])}}</span></span>
        <PieChart v-if="!printing || !chartImage" id="bpstats-chart" ref="piechart" :chartData="chartData" :labels="chartLabels" :width="600" :height="600" style="height: 200px; width: 200px;"/>
        <img v-if="printing && chartImage" :src="chartImage" style="height: 200px; width: 200px;"/>
      </div>
    </div>
  </div>
</template>

<script>
import DottedLineHeader from '@/components/DottedLineHeader.vue'
import PieChart from '@/components/PieChart.js'
import RadioButtonGroup from '@/components/RadioButtonGroup.vue'
export default {
  components: {
    DottedLineHeader,
    PieChart,
    RadioButtonGroup
  },
  props: {
    sharedTest: Object,
    printing: Boolean
  },
  watch: {
    printing (to, from) {
      if (to) {
        this.chartImage = this.$refs.piechart.export2image()
      } else {
        this.chartImage = null
      }
    }
  },
  methods: {
    filterValueChanged: function (time) {
      this.selectedTimeRange = time
      if (!this.sharedTest) {
        return
      }
      this.chartData = [this.sharedTest.stats.bp[time]['high'], this.sharedTest.stats.bp[time]['normal'], this.sharedTest.stats.bp[time]['low']]
    }
  },
  mounted () {
    var that = this
    this.chartLabels = []
    this.statusLabels.forEach(function (value) {
      that.chartLabels.push(that.$t(value))
    })
    this.filterValueChanged('today')
  },
  data: function () {
    return {
      chartImage: null,
      chartData: [0, 0, 0],
      chartLabels: ['High', 'Medium', 'Low'],
      selectedTimeRange: 'today',
      timeRangeKeys: [
        'today',
        'last7',
        'last30',
        'last90'
      ],
      timeRangeLabels: [
        'filter.today',
        'filter.last7',
        'filter.last30',
        'filter.last90'
      ],
      statusKeys: [
        'high',
        'normal',
        'low'
      ],
      statusLabels: [
        'filter.high',
        'filter.normal',
        'filter.low'
      ]
    }
  }
}
</script>

<style>
table.bp-stats-table {
  font-size: small;
  margin: 0 20px 0;
  width: 90%;
}

table.bp-stats-table td, table.bp-stats-table th {
  text-align: center !important;
}
tr td:first-child {
  text-align: start !important;
}

table.bp-stats-table th {
  color: gray;
  font-weight: normal;
}

.table-vtitle {
  font-weight: bold !important;
}

.table-htitle {
  font-weight: bold !important;
}

#bpstats-chart {
  height: 200px;
  width: 200px;
  position: relative;
  margin: 0 auto;
}

#bpstats-chart canvas {
  width: 200px !important;
  height: 200px !important;
}

.selected-time-range {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/BloodPressureStats.vue